import { createContext } from 'react'

import ComponentSize from '../../ComponentSize'
import ListVariantComponentType from './ListVariantComponent'

export interface ListVariant {
  componentType?: ListVariantComponentType
  size?: ComponentSize
  update?: (component: ListVariantComponentType, size?: ComponentSize) => void
}

export const ListVariantContext = createContext<ListVariant>({})
